"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parameter = void 0;
const Contract = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const ParameterChangedEvent_1 = require("../Events/ParameterChangedEvent");
const ServiceRegistryUtil_1 = require("../Services/ServiceRegistryUtil");
/**
 * Implementation of the Parameter contract. Calls down to the impl
 * class for almost all of the work it does.
 */
class Parameter extends api_shared_js_1.EventListenerManager {
    constructor(parameterImpl, sheet) {
        super();
        this.parameterImpl = parameterImpl;
        // Initialize our event handling for this class
        this.initializeEvents(sheet).forEach((e) => this.addNewEventType(e));
    }
    get name() {
        return this.parameterImpl.name;
    }
    get currentValue() {
        return this.parameterImpl.currentValue;
    }
    get dataType() {
        return this.parameterImpl.dataType;
    }
    get allowableValues() {
        return this.parameterImpl.allowableValues;
    }
    get id() {
        return this.parameterImpl.id;
    }
    changeValueAsync(newValue) {
        return this.parameterImpl.changeValueAsync(newValue);
    }
    /**
     * Helper method which goes through and registers each event type this impl knows about
     * with the NotificationService. It returns an array of SingleEventManager objects which
     * can then be passed to an EventListenerManager to handle user registration / unregistration.
     *
     * @param sheet The sheet object which will be included with the event notifications
     * @returns {Array<SingleEventManager>} Collection of event managers to pass to an EventListenerManager
     */
    initializeEvents(sheet) {
        api_shared_js_1.ErrorHelpers.verifyInternalValue(sheet, 'sheet');
        const results = new Array();
        let notificationService;
        try {
            notificationService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("notification-service" /* ServiceNames.Notification */);
        }
        catch (e) {
            // If we don't have this service registered, just return
            return results;
        }
        // Initialize all of the event managers we'll need (one for each event type)
        const parameterEvent = new api_shared_js_1.SingleEventManagerImpl(Contract.TableauEventType.ParameterChanged);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.ParameterChanged, (model) => {
            const fieldName = model;
            return fieldName === this.parameterImpl.id;
        }, (fieldName) => {
            parameterEvent.triggerEvent(() => new ParameterChangedEvent_1.ParameterChangedEvent(fieldName, sheet));
        });
        results.push(parameterEvent);
        return results;
    }
}
exports.Parameter = Parameter;
//# sourceMappingURL=Parameter.js.map